function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["allowInvalidDates", "autoFocus", "disableFuture", "fullWidth", "id", "initialFocusedDate", "InputLabelProps", "inputProps", "inputVariant", "label", "maxDate", "minDate", "onBlur", "onChange", "onClose", "onFocus", "onKeyDown", "onOpen", "selectedDate", "yearsDescend"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useCallback } from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { useId } from "../../hooks";
import CalendarOutline from "../../icons/CalendarOutline";
import { DatePickerStyle } from "./styles";
import { GRAY } from "../..";
import CustomDateUtils from "./CustomDateUtils";
import DateFnsUtils from '@date-io/date-fns';

/**
 *
 * This receive a date value and return it as a date object.
 * Update this function if you need to support more formats
 */
var transformValueToDate = function transformValueToDate(date) {
  if (!date) {
    return null;
  }
  if (moment.isMoment(date)) {
    return date.toDate();
  }
  if (date instanceof Date) {
    return date;
  }
  return new Date("".concat(date, "T00:00:00"));
};

/**
 * Based on the implementation of the KeyboardDatePicker
 * @see https://material-ui-pickers.dev/api/KeyboardDatePicker
 * @description If {maxDate} and {minDate} are both in the past or future.
 * On opening the datepicker it will select the minDate automatically and then close the picker
 */
export var InlineDatePicker = function InlineDatePicker(_ref) {
  var _ref$allowInvalidDate = _ref.allowInvalidDates,
    allowInvalidDates = _ref$allowInvalidDate === void 0 ? false : _ref$allowInvalidDate,
    autoFocus = _ref.autoFocus,
    _ref$disableFuture = _ref.disableFuture,
    disableFuture = _ref$disableFuture === void 0 ? false : _ref$disableFuture,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    originalId = _ref.id,
    initialFocusedDate = _ref.initialFocusedDate,
    InputLabelProps = _ref.InputLabelProps,
    inputProps = _ref.inputProps,
    _ref$inputVariant = _ref.inputVariant,
    inputVariant = _ref$inputVariant === void 0 ? 'outlined' : _ref$inputVariant,
    label = _ref.label,
    maxDate = _ref.maxDate,
    minDate = _ref.minDate,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onClose = _ref.onClose,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    onOpen = _ref.onOpen,
    selectedDate = _ref.selectedDate,
    yearsDescend = _ref.yearsDescend,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChange = useCallback(function (_, value) {
    // MUI component has a format guide and as you start typing the date
    // it will send (e.g. '199_-__-__')
    // we will only call the passed-in onChange() with null or a valid date
    if (!(value !== null && value !== void 0 && value.includes('_')) || allowInvalidDates) {
      onChange(value);
    }
  }, [onChange]);
  var uniqueId = useId();
  var id = originalId || uniqueId;
  var isOnlyYearViews = props.views && props.views.length === 1 && props.views[0] === 'year';
  return /*#__PURE__*/React.createElement(DatePickerStyle, null, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: yearsDescend ? CustomDateUtils : DateFnsUtils
  }, /*#__PURE__*/React.createElement(KeyboardDatePicker, _extends({
    id: id,
    autoOk: true
    // eslint-disable-next-line  jsx-a11y/no-autofocus
    ,
    autoFocus: autoFocus,
    animateYearScrolling: true,
    variant: "inline",
    format: isOnlyYearViews ? 'yyyy' : 'yyyy-MM-dd' // format based on https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
    ,
    placeholder: isOnlyYearViews ? 'yyyy' : 'yyyy-mm-dd',
    KeyboardButtonProps: {
      'aria-label': 'date-picker-button'
    },
    leftArrowButtonProps: {
      'aria-label': 'left-arrow-button'
    },
    rightArrowButtonProps: {
      'aria-label': 'right-arrow-button'
    }
    // high z-index to make sure the datepicker popover will never be under any components
    ,
    PopoverProps: {
      style: {
        zIndex: 10000
      },
      'aria-label': 'date-picker-popover'
    },
    keyboardIcon: /*#__PURE__*/React.createElement(CalendarOutline, {
      fill: GRAY[5]
    }),
    fullWidth: fullWidth,
    disableFuture: disableFuture,
    inputVariant: inputVariant,
    label: label,
    value: transformValueToDate(selectedDate),
    onChange: handleChange,
    onClose: onClose,
    onOpen: onOpen,
    onFocus: onFocus,
    onBlur: onBlur,
    inputProps: _objectSpread({
      onKeyDown: onKeyDown
    }, inputProps),
    maxDate: transformValueToDate(maxDate) || undefined,
    minDate: transformValueToDate(minDate) || undefined,
    initialFocusedDate: transformValueToDate(initialFocusedDate) || undefined,
    InputLabelProps: InputLabelProps
  }, props))));
};